





























import Vue from "vue";
import { Component, Prop, Model } from "vue-property-decorator";

@Component
export default class CheckcodeInput extends Vue {
  @Prop({ type: String, default: "text" }) readonly type!: string;
  @Prop({ type: Number, default: 6 }) readonly length!: number;
  @Prop({ type: String, default: "#6200ee" }) readonly highLightColor!: string;
  @Prop({ type: Number, default: 5 }) readonly margin!: number;

  @Model("change", { type: String }) readonly value!: string;

  inputSize = 0;
  valueDic = [];
  focusIndex = -1;

  mounted() {
    this.$nextTick(() => {
      const dom: any = this.$refs.checkcodeRoot;
      if (!dom) return 0;
      const { margin } = this;
      this.inputSize =
        (dom.offsetWidth - this.length * 2 * margin) / this.length;

      //
      const transformedValue: string[] = this.value.substr(0, 6).split("");
      for (let i = 0; i < this.length; i++) {
        this.valueDic.push(
          // @ts-ignore
          transformedValue.length > 0 ? transformedValue.shift() : ""
        );
      }
    });
  }

  onPaste(e: any) {
    const clipboardData = e.clipboardData;
    const code = clipboardData.getData("text/plain");
    // @ts-ignore
    this.valueDic = [""];
    for (let i = 0; i < 6 && i < code.length; i++) {
      // @ts-ignore
      this.valueDic.push(code[i]);
    }
  }

  handleInput(index: number, value: string): void {
    const dom = this.$refs[`inputItems${index}`] || undefined;
    if (!dom) return;
    if (value.length !== 0 && index !== this.length) {
      const nextDom: any = this.$refs[`inputItems${index + 1}`] || {};
      setTimeout(() => {
        nextDom.focus();
        nextDom.select();
      }, 0);
    }
    // this.valueDic[index] = value[0] || "";
    if (value.length >= 1) {
      for (
        let i = index, j = 0;
        i <= this.length && j < value.length;
        i++, j++
      ) {
        // @ts-ignore
        this.valueDic[i] = value[j] || "";
      }
    }
    this.updateValue();
  }

  handleBackspace(index: number, value: string): void {
    setTimeout(() => {
      if (value.length <= 1 && index !== 1) {
        const prevDom: any = this.$refs[`inputItems${index - 1}`] || {};
        prevDom.focus();
      }
    }, 0);
  }
  get concatValue() {
    return this.valueDic.slice(1).reduce((prev, curr) => {
      return prev + curr;
    }, "");
  }

  updateValue() {
    this.$emit("change", this.concatValue);
  }
}
